import BaseApi from '../BaseApi';
import { TransactionApiConverter } from './TransactionApiConverter';

class TransactionApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/mini_admin`;
    this.converter = new TransactionApiConverter();
  }

  createUser = (userName, password, currency) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/create_user`, {
      email: userName,
      password,
      name: '',
      currency,
    });

  getTransactions = period =>
    this.sendQuery(
      this.queryTypes.POST,
      `${this.baseUrl}/transfers`,
      {
        from_date: period.startDate,
        to_date: period.endDate,
      },
      null,
      this.converter.convertTransfers,
    );


  getWithdrawalRequests = (filters = {}) => {
    const queryString = Object.entries(filters)
      .filter(([key, value]) => value !== undefined && value !== null && value !== '')
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');

    const url = `${this.baseUrl}/cashier_withdrawal_request${queryString ? '?' + queryString : ''}`;

    return this.sendQuery(this.queryTypes.GET, url, null, null, this.converter.convertWithdrawalRequests);
  };


  getActiveRequests = (filters = {}) => {

    return this.getWithdrawalRequests(filters);
  };


  updateWithdrawalRequest = ({ cashier_withdrawal_id, confirm, cancel_reason = null }) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/cashier_withdrawal_request/update`, {
      cashier_withdrawal_id,
      confirm,
      cancel_reason,
    });
}

export default TransactionApi;
